"use client";

import { motion } from "framer-motion";
import PortfolioCarousel from "./portfolio/movies";

const movies = [
  {
    id: 1,
    src: "/portfolio/VideoApresentacaoEscapa.webm",
    title: "Bem vindo à escapa!",
    poster: "",
    description:
      "Vídeo introdutório demonstrando a história, visão e valores da escapa, e quais dores ela busca solucionar no mercado de Turismo de Luxo com o uso de Inteligência Artificial.",
  },
  {
    id: 2,
    src: "/portfolio/Escapismo.webm",
    title: "Escapismo!",
    poster: "",
    description:
      "Vídeo introdutório demonstrando a história, visão e valores da escapa, e quais dores ela busca solucionar no mercado de Turismo de Luxo com o uso de Inteligência Artificial.",
  },
  {
    id: 3,
    src: "/portfolio/VideoCompletoGramado.webm",
    title: "Bem vindo à gramado",
    poster: "",
    description: "Vídeo de apresentação do Turismo de Luxo guiado na cidade de Gramado - RS.",
  },
];

const Portfolio = () => {
  return (
    <section className="py-20 px-6 md:px-12 lg:px-24 border-t border-gray-100">
      <div className="max-w-7xl mx-auto text-center mb-12">
        <motion.h2
          className="text-3xl md:text-4xl font-bold text-blue-700 mb-2"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.5 }}
        >
          Nosso Portfólio
        </motion.h2>
        <motion.p
          className="text-gray-600 text-base md:text-lg max-w-3xl mx-auto"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          Conheça um pouco mais sobre nosso trabalho.
        </motion.p>
      </div>
      <div className="max-w-3xl mx-auto text-center mb-12">
        <PortfolioCarousel videos={movies} />
      </div>
    </section>
  );
};

export default Portfolio;
